export const AUDIO_PLAYER_HEIGHT = 49
export const POPOVER_PAPER_HEIGHT = 80
export const TIME_LINE_HEIGHT = 3
export const ICON_BUTTON_WIDTH = 50
